export const AUTH_REQUEST_STATE_KEY = 'authRequest';

export const AUTH_REQUEST_SOURCES = Object.freeze({
  PROFILE_NAVIGATION: 'profile-navigation',
});

export function createRequiredAuthRequest({ source, page } = {}) {
  return {
    source,
    page,
    required: true,
  };
}

export function isRequiredAuthRequest(authRequest) {
  return authRequest?.required === true;
}
